import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './Components/Pages/Home';
import AboutPage from './Components/Pages/AboutPage';
import Footer from './Components/Footer/Footer';
import Begginers from './Components/Pages/Begginers';
import Intermediate from './Components/Pages/Intermediate';
import AdvanceCourse from './Components/Pages/Advance';
import LevelUpHome from './Components/LevelUp/LevelUpHome/LevelUpHome';
import Roleplay from './Components/LevelUp/Roleplay/Roleplay';
import Wordgame from './Components/LevelUp/Word/Wordgame';
import JumbleWordGame from './Components/LevelUp/Jumble/Jumble';
import ScrollToTop from './Components/ScrollTop/ScrollTop';
import Navbar from './Components/Navbar/Navbar';
import Journey from './Components/Journey/Journey';


function App() {
  return (
    <Router>
      <ScrollToTop/>
      <div className="App">
        
        {/* <Header /> */}
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/beginners" element={<Begginers />} />
          <Route path="/journey" element={<Journey />} />
          <Route path="/intermediate" element={<Intermediate />} />
          <Route path="/advanced" element={<AdvanceCourse />} />
          <Route path="/levelup" element={<LevelUpHome/>} />
          <Route path="/roleplay" element={<Roleplay/>} />
          <Route path="/Wordgame" element={<Wordgame/>} />
          <Route path="/jumbleWordGame" element={<JumbleWordGame/>} />
          {/* Add more routes here if needed */}
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
